import { getStore } from "../store/store";
import { mutatorAction } from "satcheljs";

export const toggleLocalKeytipsEnabledStatusMutator: (isEnabled: boolean) => void = mutatorAction("toggleLocalKeytipsEnabledStatus", (isEnabled: boolean) => {
    getStore().enabledKeytips = isEnabled;
});
